import { action, makeObservable, observable } from "mobx"

import { OTPEntity } from "@src/pages/otpConfirm/classes/OTPEntity"
import { wrapSingleton } from "@src/shared/classes/utils/wrapSingleton"

class GlobalOTPCLass {
  entity: OTPEntity | null = null

  constructor() {
    makeObservable(this, {
      entity: observable.deep,
      onSubmit: action.bound,
    })
  }

  async onSubmit(otp: string) {
    const entity = this.entity

    if (entity) {
      return entity.confirm(otp)
    }

    return false
  }

  reset() {
    this.setEntity(null)
  }

  setEntity(entity: OTPEntity | null): void {
    this.entity = entity
  }
}

export const GlobalOTP = wrapSingleton(GlobalOTPCLass)
